module.exports = __webpack_public_path__ + "assets/close.25cfef92.svg";